export enum MappingInteractionState {
  Requested = 1,
  Accepted = 2,
  InProgress = 3,
  Completed = 4,
  Updated = 5,
}
